import { coreInitiativesTagsGetAsyncSlice } from './get';

export const { requestGetCoreInitiativesTags, resetGetCoreInitiativesTags } =
	coreInitiativesTagsGetAsyncSlice.asyncActionCreators;
